import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { FlexCenter, NumberDisplay, SpaceBetween, TextBody, TextBodySkeleton, Tooltip } from "@opensea/ui-kit";
import { Schedule } from "@opensea/ui-kit/icons";
import { bn } from "@opensea/utils";
import { useTranslations } from "use-intl";
import { SwapDetailsEstimatedDurationItemFragment } from "./SwapDetailsEstimatedDurationItem.fragment";
export function SwapDetailsEstimatedDurationItem(t0) {
  const $ = _c(14);
  const {
    swapRoute: swapRouteKey
  } = t0;
  const swapRoute = readFragment(SwapDetailsEstimatedDurationItemFragment, swapRouteKey);
  const t = useTranslations("wallet.SwapDetailsEstimatedDurationItem");
  if (!swapRoute || swapRoute.__typename !== "SwapRoute") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SwapDetailsEstimatedDurationItemSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const estimatedDurationSeconds = bn(swapRoute.estimatedDurationMs).div(1000);
  const T0 = SpaceBetween;
  let t1;
  if ($[1] !== t) {
    t1 = t("estimatedDuration");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <TextBody>{t1}</TextBody>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const T1 = FlexCenter;
  const t3 = "gap-1.5";
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Schedule fill="text-secondary" size={20} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = estimatedDurationSeconds.isZero() ? <Tooltip content={t("instantTooltip")}><TextBody>{t("instant")}</TextBody></Tooltip> : <TextBody className="font-mono"><NumberDisplay display="quantity" value={estimatedDurationSeconds} />s</TextBody>;
  let t6;
  if ($[6] !== T1 || $[7] !== t4 || $[8] !== t5) {
    t6 = <T1 className={t3}>{t4}{t5}</T1>;
    $[6] = T1;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== T0 || $[11] !== t2 || $[12] !== t6) {
    t7 = <T0>{t2}{t6}</T0>;
    $[10] = T0;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
const SwapDetailsEstimatedDurationItemSkeleton = () => {
  const $ = _c(7);
  const t = useTranslations("wallet.SwapDetailsEstimatedDurationItem");
  let t0;
  if ($[0] !== t) {
    t0 = t("estimatedDuration");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TextBody>{t0}</TextBody>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FlexCenter className="gap-1.5"><Schedule fill="text-secondary" size={20} /><TextBodySkeleton className="w-[50px]" /></FlexCenter>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <SpaceBetween>{t1}{t2}</SpaceBetween>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};